import { render, staticRenderFns } from "./payDone.vue?vue&type=template&id=0db60d86&"
import script from "./payDone.vue?vue&type=script&lang=js&"
export * from "./payDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports